import React from 'react';
import './ProblemUserface.css';

const ProblemUserface = () => {
  const problems = [
    { id: 1, name: "Delayed or Inaccurate Forex Data", percentage: 30, color: "#1e3a8a" },
    { id: 2, name: "Limited Currency Pairs & Lack of Depth", percentage: 15, color: "#3b82f6" },
    { id: 3, name: "No Historical Data for Market Analysis", percentage: 10, color: "#60a5fa" },
    { id: 4, name: "Difficult Integration & Poor Documentation", percentage: 15, color: "#a78bfa" },
    { id: 5, name: "Unreliable Uptime & Slow Response Times", percentage: 10, color: "#8b5cf6" },
    { id: 6, name: "High Costs", percentage: 10, color: "#7c3aed" },
    { id: 7, name: "Lack of customization options", percentage: 10, color: "#5b21b6" }
  ];

  // Calculate donut chart segments
  const total = problems.reduce((sum, problem) => sum + problem.percentage, 0);
  let currentAngle = 0;

  const chartSegments = problems.map((problem, index) => {
    const angle = (problem.percentage / total) * 360;
    const startAngle = currentAngle;
    currentAngle += angle;
    
    return {
      ...problem,
      startAngle,
      angle,
      endAngle: currentAngle
    };
  });

  return (
    <div className="problem-userface-container">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="section-title text-center">Problems Users Face:</h2>
          </div>
        </div>
        <div className="row align-items-start">
          <div className="col-lg-6">
            <div className="problems-list">
              {problems.map((problem) => (
                <div key={problem.id} className="problem-item">
                  <div className="problem-number">{problem.id}.</div>
                  <div className="problem-content">
                    <div className="problem-name">{problem.name}</div>
                    <div className="problem-percentage">- {problem.percentage}%</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="chart-container">
              <div className="chart-wrapper">
                <div className="donut-chart">
                  <svg width="300" height="300" viewBox="0 0 300 300">
                    <circle
                      cx="150"
                      cy="150"
                      r="120"
                      fill="none"
                      stroke="#e5e7eb"
                      strokeWidth="40"
                    />
                    {chartSegments.map((segment, index) => {
                      const radius = 120;
                      const centerX = 150;
                      const centerY = 150;
                      
                      const startAngleRad = (segment.startAngle - 90) * (Math.PI / 180);
                      const endAngleRad = (segment.endAngle - 90) * (Math.PI / 180);
                      
                      const x1 = centerX + radius * Math.cos(startAngleRad);
                      const y1 = centerY + radius * Math.sin(startAngleRad);
                      const x2 = centerX + radius * Math.cos(endAngleRad);
                      const y2 = centerY + radius * Math.sin(endAngleRad);
                      
                      const largeArcFlag = segment.angle > 180 ? 1 : 0;
                      
                      const pathData = [
                        `M ${x1} ${y1}`,
                        `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`
                      ].join(' ');
                      
                      return (
                        <path
                          key={index}
                          d={pathData}
                          fill="none"
                          stroke={segment.color}
                          strokeWidth="40"
                          strokeLinecap="round"
                        />
                      );
                    })}
                  </svg>
                  <div className="chart-center">
                    <div className="total-percentage">100%</div>
                    <div className="total-label">Total</div>
                  </div>
                </div>
                
                <div className="chart-legend">
                  {problems.map((problem, index) => (
                    <div key={index} className="legend-item">
                      <div 
                        className="legend-color" 
                        style={{ backgroundColor: problem.color }}
                      ></div>
                      <div className="legend-text">{problem.name}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProblemUserface; 